import { render, staticRenderFns } from "./add-edit-multi-consent-privacy-policy.vue?vue&type=template&id=aa864250&scoped=true&"
import script from "./add-edit-multi-consent-privacy-policy.vue?vue&type=script&lang=js&"
export * from "./add-edit-multi-consent-privacy-policy.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-multi-consent-privacy-policy.vue?vue&type=style&index=0&id=aa864250&scoped=true&lang=scss&"
import style1 from "./styles/add-edit-multi-consent.scss?vue&type=style&index=1&id=aa864250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa864250",
  null
  
)

component.options.__file = "add-edit-multi-consent-privacy-policy.vue"
export default component.exports